import { useSyncExternalStore } from 'react';

/**
 * How-to-Play visibility (v7). A tiny external store — the same pattern as the
 * sim store — so Landing, Lobby, and the in-round "?" chip can all open the page
 * without threading props through the screen switch. App renders <HowToPlay/> as
 * an overlay when `open` is true; the underlying screen (and a live round) keeps
 * running beneath it.
 */
let open = false;
const subs = new Set<() => void>();
const emit = () => subs.forEach((s) => s());

export const helpStore = {
  snapshot: () => open,
  open() {
    if (!open) {
      open = true;
      emit();
    }
  },
  close() {
    if (open) {
      open = false;
      emit();
    }
  },
  subscribe(cb: () => void) {
    subs.add(cb);
    return () => subs.delete(cb);
  },
};

export function useHelpOpen(): boolean {
  return useSyncExternalStore(helpStore.subscribe, helpStore.snapshot, helpStore.snapshot);
}
